module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 7
// module chunks = 0